import { Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "@/features/auth/LoginPage";
import { Layout } from "@/components/Layout";
import { AuthGuard } from "@/components/AuthGuard";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { ItemsPage } from "@/features/catalog/ItemsPage";
import { VendorsPage } from "@/features/catalog/VendorsPage";
import { CustomersPage } from "@/features/catalog/CustomersPage";
import { UomsPage } from "@/features/catalog/UomsPage";
import { ItemCategoriesPage } from "@/features/catalog/ItemCategoriesPage";
import { ItemFormsPage } from "@/features/catalog/ItemFormsPage";
import { ServicesPage } from "@/features/catalog/ServicesPage";
import { StockPage } from "@/features/inventory/StockPage";
import { StockAdjustmentsPage } from "@/features/inventory/StockAdjustmentsPage";
import { CreateStockAdjustmentPage } from "@/features/inventory/CreateStockAdjustmentPage";
import { StockAdjustmentDetailPage } from "@/features/inventory/StockAdjustmentDetailPage";
import { StockWriteOffsPage } from "@/features/inventory/StockWriteOffsPage";
import { CreateStockWriteOffPage } from "@/features/inventory/CreateStockWriteOffPage";
import { StockWriteOffDetailPage } from "@/features/inventory/StockWriteOffDetailPage";
import { InternalTransfersPage } from "@/features/inventory/InternalTransfersPage";
import { CreateInternalTransferPage } from "@/features/inventory/CreateInternalTransferPage";
import { InternalTransferDetailPage } from "@/features/inventory/InternalTransferDetailPage";
import { StockTakesPage } from "@/features/inventory/StockTakesPage";
import { CreateStockTakePage } from "@/features/inventory/CreateStockTakePage";
import { StockTakeDetailPage } from "@/features/inventory/StockTakeDetailPage";
import { NearExpiryPage } from "@/features/inventory/NearExpiryPage";
import { PredictiveReorderPage } from "@/features/inventory/PredictiveReorderPage";
import { NarcoticRegisterPage } from "@/features/inventory/NarcoticRegisterPage";
import { ReorderQueuePage } from "@/features/procurement/ReorderQueuePage";
import { PurchaseInvoicesPage } from "@/features/procurement/PurchaseInvoicesPage";
import { CreatePurchaseInvoicePage } from "@/features/procurement/CreatePurchaseInvoicePage";
import { CreateDirectPurchaseInvoicePage } from "@/features/procurement/CreateDirectPurchaseInvoicePage";
import { PurchaseInvoiceDetailPage } from "@/features/procurement/PurchaseInvoiceDetailPage";
import { ManualJournalPage } from "@/features/accounting/ManualJournalPage";
import { JournalsListPage } from "@/features/accounting/JournalsListPage";
import { JournalEntryDetailPage } from "@/features/accounting/JournalEntryDetailPage";
import { PeriodsPage } from "@/features/accounting/PeriodsPage";
import { ChartOfAccountsPage } from "@/features/accounting/ChartOfAccountsPage";
import { ReportsHubPage } from "@/features/reporting/ReportsHubPage";
import { TrialBalancePage } from "@/features/reporting/TrialBalancePage";
import { StockOnHandPage } from "@/features/reporting/StockOnHandPage";
import { PoStatusReportPage } from "@/features/reporting/PoStatusReportPage";
import { DailySalesReportPage } from "@/features/reporting/DailySalesReportPage";
import { AuditLogPage } from "@/features/admin/AuditLogPage";
import { DemoGuidePage } from "@/features/demo/DemoGuidePage";
import { PermissionMatrixPage } from "@/features/admin/PermissionMatrixPage";
import { FeatureFlagsPage } from "@/features/admin/FeatureFlagsPage";
import { TenantSettingsPage } from "@/features/admin/TenantSettingsPage";
import { BranchesPage } from "@/features/admin/BranchesPage";
import { WarehousesPage } from "@/features/admin/WarehousesPage";
import { TransferOrdersPage } from "@/features/transfer/TransferOrdersPage";
import { CreateTransferOrderPage } from "@/features/transfer/CreateTransferOrderPage";
import { TransferOrderDetailPage } from "@/features/transfer/TransferOrderDetailPage";
import { TransferRequisitionsPage } from "@/features/transfer/TransferRequisitionsPage";
import { CreateTransferRequisitionPage } from "@/features/transfer/CreateTransferRequisitionPage";
import { TransferRequisitionDetailPage } from "@/features/transfer/TransferRequisitionDetailPage";
import { ShipmentsPage } from "@/features/transport/ShipmentsPage";
import { ShipmentDetailPage } from "@/features/transport/ShipmentDetailPage";
import { CarriersPage } from "@/features/transport/CarriersPage";
import { VehiclesPage } from "@/features/transport/VehiclesPage";
import { DriversPage } from "@/features/transport/DriversPage";
import { PriceListsPage } from "@/features/pricing/PriceListsPage";
import { PurchaseRequisitionsPage } from "@/features/procurement/PurchaseRequisitionsPage";
import { CreatePurchaseRequisitionPage } from "@/features/procurement/CreatePurchaseRequisitionPage";
import { PurchaseRequisitionDetailPage } from "@/features/procurement/PurchaseRequisitionDetailPage";
import { QuotationsPage } from "@/features/procurement/QuotationsPage";
import { ConsolidatedStockPage } from "@/features/reporting/ConsolidatedStockPage";
import { AgingPage } from "@/features/reporting/AgingPage";
import { IpBillingPage } from "@/features/sales/IpBillingPage";
import { PurchaseOrdersPage } from "@/features/procurement/PurchaseOrdersPage";
import { CreatePurchaseOrderPage } from "@/features/procurement/CreatePurchaseOrderPage";
import { PurchaseOrderDetailPage } from "@/features/procurement/PurchaseOrderDetailPage";
import { GrnsPage } from "@/features/procurement/GrnsPage";
import { CreateGrnPage } from "@/features/procurement/CreateGrnPage";
import { GrnDetailPage } from "@/features/procurement/GrnDetailPage";
import { SalesInvoicesPage } from "@/features/sales/SalesInvoicesPage";
import { CreateSalesInvoicePage } from "@/features/sales/CreateSalesInvoicePage";
import { SalesInvoiceDetailPage } from "@/features/sales/SalesInvoiceDetailPage";
import { UsersPage } from "@/features/admin/UsersPage";
import { RolesPage } from "@/features/admin/RolesPage";
import { WardIssuesPage } from "@/features/hospital/WardIssuesPage";
import { CreateWardIssuePage } from "@/features/hospital/CreateWardIssuePage";
import { OtConsumptionsPage } from "@/features/hospital/OtConsumptionsPage";
import { CreateOtConsumptionPage } from "@/features/hospital/CreateOtConsumptionPage";
import { CssdTraysPage } from "@/features/hospital/CssdTraysPage";
import { HealNTrackPage } from "@/features/integration/HealNTrackPage";
import { EInvoicesPage } from "@/features/integration/EInvoicesPage";
import { EWayBillsPage } from "@/features/integration/EWayBillsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />

        <Route path="catalog/items" element={<ItemsPage />} />
        <Route path="catalog/vendors" element={<VendorsPage />} />
        <Route path="catalog/customers" element={<CustomersPage />} />
        <Route path="catalog/uoms" element={<UomsPage />} />
        <Route path="catalog/item-categories" element={<ItemCategoriesPage />} />
        <Route path="catalog/item-forms" element={<ItemFormsPage />} />
        <Route path="catalog/services" element={<ServicesPage />} />

        <Route path="inventory/stock" element={<StockPage />} />
        <Route path="inventory/adjustments" element={<StockAdjustmentsPage />} />
        <Route path="inventory/adjustments/new" element={<CreateStockAdjustmentPage />} />
        <Route path="inventory/adjustments/:id" element={<StockAdjustmentDetailPage />} />
        <Route path="inventory/writeoffs" element={<StockWriteOffsPage />} />
        <Route path="inventory/writeoffs/new" element={<CreateStockWriteOffPage />} />
        <Route path="inventory/writeoffs/:id" element={<StockWriteOffDetailPage />} />
        <Route path="inventory/internal-transfers" element={<InternalTransfersPage />} />
        <Route path="inventory/internal-transfers/new" element={<CreateInternalTransferPage />} />
        <Route path="inventory/internal-transfers/:id" element={<InternalTransferDetailPage />} />
        <Route path="inventory/stocktakes" element={<StockTakesPage />} />
        <Route path="inventory/stocktakes/new" element={<CreateStockTakePage />} />
        <Route path="inventory/stocktakes/:id" element={<StockTakeDetailPage />} />
        <Route path="inventory/near-expiry" element={<NearExpiryPage />} />
        <Route path="inventory/predictive-reorder" element={<PredictiveReorderPage />} />
        <Route path="inventory/narcotic-register" element={<NarcoticRegisterPage />} />
        <Route path="procurement/reorder-queue" element={<ReorderQueuePage />} />
        <Route path="procurement/purchase-invoices" element={<PurchaseInvoicesPage />} />
        <Route path="procurement/purchase-invoices/new" element={<CreatePurchaseInvoicePage />} />
        <Route path="procurement/purchase-invoices/direct" element={<CreateDirectPurchaseInvoicePage />} />
        <Route path="procurement/purchase-invoices/:id" element={<PurchaseInvoiceDetailPage />} />
        <Route path="procurement/quotations" element={<QuotationsPage />} />

        <Route path="accounting/journals" element={<JournalsListPage />} />
        <Route path="accounting/journals/new" element={<ManualJournalPage />} />
        <Route path="accounting/journals/:id" element={<JournalEntryDetailPage />} />
        <Route path="accounting/periods" element={<PeriodsPage />} />
        <Route path="accounting/chart-of-accounts" element={<ChartOfAccountsPage />} />

        <Route path="reports" element={<ReportsHubPage />} />
        <Route path="reports/trial-balance" element={<TrialBalancePage />} />
        <Route path="reports/stock-on-hand" element={<StockOnHandPage />} />
        <Route path="reports/po-status" element={<PoStatusReportPage />} />
        <Route path="reports/daily-sales" element={<DailySalesReportPage />} />

        <Route path="admin/audit" element={<AuditLogPage />} />
        <Route path="admin/permissions" element={<PermissionMatrixPage />} />
        <Route path="admin/feature-flags" element={<FeatureFlagsPage />} />
        <Route path="admin/tenant-settings" element={<TenantSettingsPage />} />
        <Route path="admin/branches" element={<BranchesPage />} />
        <Route path="admin/warehouses" element={<WarehousesPage />} />

        <Route path="warehouse/transfers" element={<TransferOrdersPage />} />
        <Route path="warehouse/transfers/new" element={<CreateTransferOrderPage />} />
        <Route path="warehouse/transfers/:id" element={<TransferOrderDetailPage />} />
        <Route path="warehouse/transfer-requisitions" element={<TransferRequisitionsPage />} />
        <Route path="warehouse/transfer-requisitions/new" element={<CreateTransferRequisitionPage />} />
        <Route path="warehouse/transfer-requisitions/:id" element={<TransferRequisitionDetailPage />} />

        <Route path="transport/shipments" element={<ShipmentsPage />} />
        <Route path="transport/shipments/:id" element={<ShipmentDetailPage />} />
        <Route path="transport/carriers" element={<CarriersPage />} />
        <Route path="transport/vehicles" element={<VehiclesPage />} />
        <Route path="transport/drivers" element={<DriversPage />} />
        <Route path="pricing/price-lists" element={<PriceListsPage />} />
        <Route path="procurement/purchase-requisitions" element={<PurchaseRequisitionsPage />} />
        <Route path="procurement/purchase-requisitions/new" element={<CreatePurchaseRequisitionPage />} />
        <Route path="procurement/purchase-requisitions/:id" element={<PurchaseRequisitionDetailPage />} />
        <Route path="reports/consolidated-stock" element={<ConsolidatedStockPage />} />
        <Route path="reports/aging" element={<AgingPage />} />
        <Route path="sales/ip-billing" element={<IpBillingPage />} />
        <Route path="demo-guide" element={<DemoGuidePage />} />

        <Route path="procurement/purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="procurement/purchase-orders/new" element={<CreatePurchaseOrderPage />} />
        <Route path="procurement/purchase-orders/:id" element={<PurchaseOrderDetailPage />} />
        <Route path="procurement/grns" element={<GrnsPage />} />
        <Route path="procurement/grns/new" element={<CreateGrnPage />} />
        <Route path="procurement/grns/:id" element={<GrnDetailPage />} />

        <Route path="sales/invoices" element={<SalesInvoicesPage />} />
        <Route path="sales/invoices/new" element={<CreateSalesInvoicePage />} />
        <Route path="sales/invoices/:id" element={<SalesInvoiceDetailPage />} />

        <Route path="admin/users" element={<UsersPage />} />
        <Route path="admin/roles" element={<RolesPage />} />

        <Route path="hospital/ward" element={<WardIssuesPage />} />
        <Route path="hospital/ward/new" element={<CreateWardIssuePage />} />
        <Route path="hospital/ot" element={<OtConsumptionsPage />} />
        <Route path="hospital/ot/new" element={<CreateOtConsumptionPage />} />
        <Route path="hospital/cssd" element={<CssdTraysPage />} />
        <Route path="integration/healntrack" element={<HealNTrackPage />} />
        <Route path="integration/einvoices" element={<EInvoicesPage />} />
        <Route path="integration/ewaybills" element={<EWayBillsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
